import React, { Component, Fragment, useEffect, useState } from "react";  
import toast, { Toaster } from "react-hot-toast";
import I18n from "i18n-js";
import _ from "lodash";

import api from "../api";

import useRoutingState from "../hooks/useRoutingState";

import PageTitle from "../commons/PageTitle";
import TierSelector from "../commons/TierSelector";

import TeamStageTable from "./components/TeamStageTable";
import TeamHealthScoreTable from "./components/TeamHealthScoreTable";
import TeamHealthTable from "./components/TeamHealthTable";
import SelfReportedTeamMetricsTable from "./components/SelfReportedTeamMetricsTable";
import LeadershipHealthTable from "./components/LeadershipHealthTable";
import MemberHealthTable from "./components/MemberHealthTable";
import LoadingMembersHealths from "./components/LoadingMembersHealths";

const datasets = [
  "team_stage",
  "team_health_score",
  "team_health",
  "self_reported_metrics",
  "leadership_health",
  "members"
];

const Insights = ({ uuid, user, team, teams, isTeamLeadOrAbove }) => {
  useRoutingState();

  const [data, setData] = useState({
    team_stage: {
      loading: true,
      data: {},
    },
    team_health_score: {
      loading: true,
      data: {},
    },
    team_health: {
      loading: true,
      data: {},
    },
    self_reported_metrics: {
      loading: true,
      data: {},
    },
    leadership_health: {
      loading: true,
      data: {},
    }
  });

  const [members, setMembers] = useState({ loading: true, dispatched: false, data: {} });

  useEffect(() => {
    loadAllDatasets();
  }, []);

  useEffect(() => {
    if (members?.loading || members?.dispatched) return;
    loadMembers();
  }, [members]);

  const loadAllDatasets = () => {
    datasets.forEach(set => {
      api.get(`/teams/${team?.uuid}/insights/${uuid}/dataset?dataset=${set}`)
        .then(res => {
          if (set === "members") {
            let membersData = {};
            res.data.data?.forEach(member => {
              membersData[member?.uuid] = {
                loading: true,
                data: member
              };
            });
            setMembers({ loading: false, data: membersData });
          } else {
            setData(data => ({ ...data, [set]: { loading: false, data: res.data.data } }));
          }
          console.log(res.data, data);
        })
        .catch(err => {
          if (err.response && err.response.data && err.response.data.message) {
            toast.error(<b>{err.response.data.message}</b>);
          } else {
            toast.error(<b>{I18n.t("common.errors.unexpected_error")}</b>);
          }
          setData({ ...data, [set]: { ...data[set], loading: false }});
          console.error(err);
        });
    });
  }

  const loadMembers = () => {
    _.forEach(members?.data, (member) => {
      const user_uuid = member?.data?.uuid;
      api.get(`/teams/${team?.uuid}/insights/${uuid}/member?user_uuid=${user_uuid}`)
        .then(res => {
          const membersData = members?.data;
          membersData[user_uuid] = {
            loading: false,
            data: { ...membersData[user_uuid]?.data, ...res?.data?.data }
          };
          setMembers(members => ({ ...members, data: membersData }));
          console.log(res.data, data);
        })
        .catch(err => {
          if (err.response && err.response.data && err.response.data.message) {
            toast.error(<b>{err.response.data.message}</b>);
          } else {
            toast.error(<b>{I18n.t("common.errors.unexpected_error")}</b>);
          }
          console.error(err);
        });
    });
    setMembers(members => ({ ...members, dispatched: true }));
  }

  const renderTierSelector = () => (
    <div className="dashboard-row selector">
      <PageTitle
        title={I18n.t("insights.page.title")}
        selectors={
          <TierSelector
            user={user}
            teams={teams}
            selectedTeam={team}
            isTeamLeadOrAbove={isTeamLeadOrAbove}
          />
        }
        showBack
      />
    </div>
  );
    
  return (
    <Fragment>
      <div className="wrapper">
        <div className="dashboard insights">
          <div className="container-fluid">
            {renderTierSelector()}
            <div className="dashboard-content">
              <div className="dashboard-row">
                <TeamStageTable {...data["team_stage"]} />
                <TeamHealthScoreTable {...data["team_health_score"]} />
                <TeamHealthTable {...data["team_health"]} />
                <SelfReportedTeamMetricsTable {...data["self_reported_metrics"]} />
                <LeadershipHealthTable {...data["leadership_health"]} />
                {members?.loading ? (
                  <LoadingMembersHealths />
                ) : members?.data
                    ? _.map(members?.data, (member, key) => (
                        <MemberHealthTable key={key} data={member?.data} loading={member?.loading} />
                      ))
                    : null
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      <Toaster
        position="top-right"
        reverseOrder
      />
    </Fragment>
  );
}

// NOTE: needed now to current version of ReactOnRails to work with hooks
export default class InsightsComponent extends Component {
  render() {
    return <Insights {...this.props} />;
  }
}